"use server";

import { cookies } from "next/headers";

import { isLocale, localeCookieName, type Locale } from "@/i18n/config";

export async function setLocale(locale: Locale): Promise<void> {
  if (!isLocale(locale)) throw new TypeError("Unsupported locale");

  (await cookies()).set(localeCookieName, locale, {
    httpOnly: true,
    maxAge: 31_536_000,
    path: "/",
    sameSite: "lax",
    secure: process.env.NODE_ENV === "production",
  });
}
